export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-collapse/index.js